"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const defaultScene_1 = __importDefault(require("./defaultScene"));
function defaultSceneLayout() {
    return {
        ...(0, defaultScene_1.default)(),
        id: undefined,
        sceneName: 'New Scene Layout',
        width: 1920,
        height: 1080,
        transform: {
            scale: 0.4,
            scaleX: 0.4,
            scaleY: 0.4,
        },
        isTemplate: true,
    };
}
exports.default = defaultSceneLayout;
